<div #listScrollContainer class="restro-details-wrap" (scroll)="onRestroScroll(); onListScrollPosition()"
     (touchmove)="hideSearchBar()">
  <div class="row">
    <div class="col-12 list-paging" *ngIf="hasEarlierBusinesses" #pagingSentinel data-paging="previous" aria-hidden="true">
      <span *ngIf="pagingDirection === 'previous'" class="list-paging-spinner"></span>
    </div>
    <div style="cursor: pointer" #restaurantListItems id="{{i}}" *ngFor="let item of restaurantDetailsList; let i=index; trackBy: trackById"
         [@fadeIn]="item.isVisible ? 'visible' : 'hidden'" [ngClass]="gridView ? 'col-6 col-md-12' : 'col-12'"
         [attr.data-listing-index]="item.index">
      <div class="restro-block" *ngIf="!isFromMobileApp" [id]="item.id" data-tour="restaurant-card" [attr.data-tour-business-id]="item.id"
           [attr.role]="isTourRestaurant(item) ? 'button' : null" [attr.tabindex]="isTourRestaurant(item) ? 0 : null"
           [attr.aria-label]="isTourRestaurant(item) ? 'Explore ' + item.restaurantName : null"
           (keydown)="onTourRestaurantKey($event, item, restaurantDetailModalComponent.restaurantDetailModalTemplate)" (click)="
            openRestroContentModal(
              restaurantDetailModalComponent.restaurantDetailModalTemplate,
              item
            )
          " (mouseenter)="getCoordinates(item.coordinate)" (mouseleave)="resetMarkerIcon(item.coordinate)">
        <img [businessImage]="cardImageUrl(item)" [businessImagePending]="cardImagePending(item)" [businessImageEager]="true" (businessImageError)="onCardImageError(item, $event)" alt="Restaurant"
             businessImageFallback="./assets/images/blank-image.svg" loading="eager" decoding="async" width="226" height="156" class="restro-view" />
        <!-- Paid What's On placement: rides on the photo's top-right corner so the name keeps its width. -->
        <app-deals-pill [branchId]="item.id"></app-deals-pill>

        <div class="restro-block-inner">
          <div class="inner-head">
            <h4 class="restro-title" *ngIf="!modalViewActive">
              <span class="count">{{ item.index || i + 1 }}.</span>
              <span>{{ item.restaurantName }}</span>
              <span class="status">{{ item.status }}</span>
            </h4>
            <h4 class="restro-title" *ngIf="modalViewActive" style="cursor: pointer">
              <span class="count">{{ item.index || i + 1 }}.</span>
              <span>{{ item.restaurantName }}</span>
              <span class="status">{{ item.status }}</span>
            </h4>
            <div *ngIf="item.rating" class="ratig-inner">
              <h5 class="ratings">{{ item.rating }}</h5>
              <span class="rating-icon">
                <img src="./assets/images/ic-primary-rating.svg" alt="Rating" />
              </span>
            </div>
          </div>
          <ul class="key-points" [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
            <li *ngFor="let chip of item.tags | slice:0:visibleChipCount">
              <span>{{ chip }}</span>
            </li>
            <li *ngIf="item.showMore">
              <ng-container *ngFor="let chip of item.tags; let i=index">
                <ng-container *ngIf="i >= visibleChipCount">
                  <span>{{chip}}</span>
                </ng-container>
              </ng-container>
            </li>
            <a *ngIf="item.tags.length > visibleChipCount && !item.showMore" class="primary-link" role="button" tabindex="0"
               (mouseover)="showMoreTags(item)" (click)="showMoreTags(item, $event)"
               (keydown.enter)="showMoreTags(item, $event)">{{ '... +' + (item.tags.length - visibleChipCount) }}</a>
          </ul>
          <ul class="other-info d-none d-md-block">
            <li *ngIf="item?.openWeeksHours?.length">
              <img src="./assets/images/ic-clock-primary-light.svg" alt="" />
              <ng-container *ngFor="let hours of item?.openWeeksHours; let i = index">
                <ng-container *ngIf="i === 0">
                  <div>{{ hours + '&nbsp;'}}</div>
                  <div [ngbTooltip]="hoursSlot" [triggers]="hoursTooltipTriggers" placement="top" tooltipClass="theme-tooltip" container="body"
                       class="pointer" role="button" tabindex="0" aria-label="Show opening hours for every day"
                       (click)="$event.stopPropagation()"
                       style="margin-top: -1px;margin-left: 4px;" *ngIf="item?.openWeeksHours.length - 1 != 0">
                    +{{
                    (item?.openWeeksHours.length - 1 > 1) ?
                    item?.openWeeksHours.length
                    - 1 + ' more slots' : item?.openWeeksHours.length - 1 + ' more slot'
                    }}
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #hoursSlot>
                <p *ngFor="let item of item.toolTipHours;" class="tooltip-line">
                  <span class="tooltip-day">{{ getDayName(item.day) }}</span>
                  <span class="tooltip-time">{{ item.from }}</span>
                  <span class="tooltip-separator">-</span>
                  <span class="tooltip-time">{{ item.to }}</span>
                </p>
              </ng-template>
            </li>
            <li *ngIf="item.address">
              <img src="./assets/images/ic-location.svg" style="margin-top:2px" alt="" />
              <!-- stopPropagation: the whole card opens the preview modal, and tapping
                   the address should go to directions instead. -->
              <a *ngIf="item.directionsUrl; else plainAddress" class="address-link"
                 [href]="item.directionsUrl" target="_blank" rel="noopener noreferrer"
                 title="Get directions" [attr.aria-label]="'Get directions to ' + item.restaurantName"
                 (click)="$event.stopPropagation()">{{ item.address }}</a>
              <ng-template #plainAddress><span>{{ item.address }}</span></ng-template>
            </li>
          </ul>
          <div class="cuisines-count-wrap d-md-none" [ngClass]="{ 'd-none': !gridView }">
            <div *ngIf="item.cuisineName" class="cuisines-count">{{item.cuisineName}}</div>
            <h5 class="price" *ngIf="item.priceRange">{{item.priceRange}}</h5>
          </div>
        </div>

      </div>
      <div class="restro-block" *ngIf="isFromMobileApp" [id]="item.id" [attr.data-id]="item.id">
        <img [businessImage]="cardImageUrl(item)" [businessImagePending]="cardImagePending(item)" [businessImageEager]="true" (businessImageError)="onCardImageError(item, $event)" alt="Restaurant"
             businessImageFallback="./assets/images/blank-image.svg" loading="eager" decoding="async" width="226" height="156" class="restro-view" />
        <!-- Paid What's On placement: rides on the photo's top-right corner so the name keeps its width. -->
        <app-deals-pill [branchId]="item.id"></app-deals-pill>

        <div class="restro-block-inner">
          <div class="inner-head">
            <h4 class="restro-title" *ngIf="!modalViewActive">
              <span class="count">{{ item.index || i + 1 }} .</span>
              <span>{{ item.restaurantName }}</span>
              <span class="status">{{ item.status }}</span>
            </h4>
            <h4 class="restro-title" *ngIf="modalViewActive" style="cursor: pointer">
              <span class="count">{{ item.index || i + 1 }} .</span>
              <span>{{ item.restaurantName }}</span>
              <span class="status">{{ item.status }}</span>
            </h4>
            <div *ngIf="item.rating" class="ratig-inner">
              <h5 class="ratings">{{ item.rating }}</h5>
              <span class="rating-icon">
                <img src="./assets/images/ic-primary-rating.svg" alt="Rating" />
              </span>
            </div>
          </div>
          <ul class="key-points" [ngClass]="gridView ? 'd-none d-md-flex' : 'd-flex'">
            <li *ngFor="let chip of item.tags | slice:0:visibleChipCount">
              <span>{{ chip }}</span>
            </li>
            <li *ngIf="item.showMore">
              <ng-container *ngFor="let chip of item.tags; let i=index">
                <ng-container *ngIf="i >= visibleChipCount">
                  <span>{{chip}}</span>
                </ng-container>
              </ng-container>
            </li>
            <a *ngIf="item.tags.length > visibleChipCount && !item.showMore" class="primary-link" role="button" tabindex="0"
               (mouseover)="showMoreTags(item)" (click)="showMoreTags(item, $event)"
               (keydown.enter)="showMoreTags(item, $event)">{{ '... +' + (item.tags.length - visibleChipCount) }}</a>
          </ul>
          <ul class="other-info d-none d-md-block">
            <li *ngIf="item?.openWeeksHours?.length">
              <img src="./assets/images/ic-clock-primary-light.svg" alt="" />
              <ng-container *ngFor="let hours of item?.openWeeksHours; let i = index">
                <ng-container *ngIf="i === 0">
                  <div>{{ hours + '&nbsp;'}}</div>
                  <div [ngbTooltip]="hoursSlot" [triggers]="hoursTooltipTriggers" placement="top" style="margin-left:4px;margin-top:-1px"
                       class="pointer" role="button" tabindex="0" aria-label="Show opening hours for every day"
                       (click)="$event.stopPropagation()"
                       tooltipClass="theme-tooltip" container="body" *ngIf="item?.openWeeksHours.length - 1 != 0">
                    +{{
                    (item?.openWeeksHours.length - 1 >
                    1) ?
                    item?.openWeeksHours.length
                    - 1 + ' more slots' : item?.openWeeksHours.length - 1 + ' more slot'
                    }}
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #hoursSlot>
                <table>
                  <tbody>
                    <tr *ngFor="let item of item.toolTipHours; let i = index" class="tooltip-line">
                      <td>
                        <span class="tooltip-day">{{ getDayName(item.day) }}</span>
                      </td>
                      <td>
                        <span class="tooltip-time t-from">{{ item.from }}</span>
                      </td>
                      <td>
                        <span class="tooltip-separator">-</span>
                      </td>
                      <td>
                        <span class="tooltip-time t-to">{{ item.to }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-template>
            </li>
            <li *ngIf="item.address">
              <img src="./assets/images/ic-location.svg" style="margin-top:3px" alt="" />
              <a *ngIf="item.directionsUrl; else plainAddress" class="address-link"
                 [href]="item.directionsUrl" target="_blank" rel="noopener noreferrer"
                 title="Get directions" [attr.aria-label]="'Get directions to ' + item.restaurantName"
                 (click)="$event.stopPropagation()">{{ item.address }}</a>
              <ng-template #plainAddress><span>{{ item.address }}</span></ng-template>
            </li>
          </ul>
          <div class="cuisines-count-wrap d-md-none" [ngClass]="{ 'd-none': !gridView }">
            <div *ngIf="item.cuisineName" class="cuisines-count">{{item.cuisineName}}</div>
            <h5 class="price" *ngIf="item.priceRange">{{item.priceRange}}</h5>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isCall" class="restaurant-list-end d-flex justify-content-center mb-5">
      <div class="col-12">
        <div *ngIf="hasMoreBusinesses" class="list-paging" #pagingSentinel data-paging="next"
             role="status" [attr.aria-busy]="pagingDirection === 'next'"
             [attr.aria-label]="pagingDirection === 'next' ? 'Loading more restaurants' : null">
          <span *ngIf="pagingDirection === 'next'" class="list-paging-spinner"></span>
        </div>
        <div *ngIf="!isLoading && restaurantDetailsList?.length == 0 && (businessFilter?.search != null && businessFilter?.search != undefined && (searchRestaurantList != null && searchRestaurantList?.total == 0))" class="w-100 py-3 text-center busns-nt-found mb-3">
          No Business Found Closeby
        </div>
        <button type="submit" [disabled]="isLoading" *ngIf="businessFilter.zoomLevel > 12 && (businessFilter?.search == null || businessFilter?.search == undefined || businessFilter?.search == '')" class="btn btn-light w-100 py-3 text-center expand-btn mb-3" (click)="onExpandList()">
          Expand Search Area
        </button>
        <button type="submit" [disabled]="isLoading" *ngIf="searchRestaurantList != null && searchRestaurantList?.total > 0 && restaurantDetailsList?.length == 0" class="btn btn-light w-100 py-3 text-center expand-btn text-no-underline" (click)="onExpandSearch()">
          No restaurants found within map area,<span class="text-underlines" style="padding-left:5px;"> search other areas?</span>
        </button>
        <div type="submit" *ngIf="!isLoading && !loadError && restaurantDetailsList?.length == 0 && businessFilter.zoomLevel <= 12 && (businessFilter?.search == null || businessFilter?.search == undefined || businessFilter?.search == '')" class="btn btn-light w-100 py-3 text-center expand-btn text-no-underline d-flex justify-content-center align-items-center">
          No Business Found Closeby
        </div>
      </div>
    </div>
  </div>
</div>
<app-restaurant-detail-modal #restaurantDetail [restaurantDetails]="item"></app-restaurant-detail-modal>
